import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import privacy from '../views/privacy.vue'
import privacyAbstract from '../views/privacyAbstract.vue'
import agreement from '../views/agreement.vue'
import storeSpreadPage from '../views/storeSpreadPage.vue'
import distribution from '../views/distribution.vue'
import distributionLoadApp from '../views/distributionLoadApp.vue'
import storeServe from '../views/storeServe'
import recruit from '../views/recruit'
import storeExamineResult from '../views/storeExamineResult'
import technicianExamineNotice from '../views/technicianExamineNotice'
import yuean from '../views/yuean'
import yuegedan from '../views/yuegedan'
import privacy2 from '../views/privacy2'
import privacy3 from '../views/privacy3'
import privacyMechanic from '../views/privacyMechanic'
import privacyMerchant from '../views/privacyMerchant'
import agreement2 from '../views/agreement2'
import agreement3 from '../views/agreement3'
import agreement4 from '../views/agreement4'
import agreement5 from '../views/agreement5'
import privacy4 from '../views/privacy4'
import avatarRequire from '../views/avatarRequire'
import joinSDKNotice from '../views/joinSDKNotice'
import userInformation from '../views/userInformation'
import information from '../views/userInformation/information'
import agreementJk from '../views/agreementJk'
import privacyJk from '../views/privacyJk'
import supportJk from '../views/supportJk'
import privacyyyjd from '../views/privacyyyjd'
import agreementyyjd from '../views/agreementyyjd'
import yyjdPromise from '../views/yyjdPromise.vue'



Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'index',
  component: index
}, {
  path: '/privacy',
  name: 'privacy',
  component: privacy,
  meta: {
    title: '隐私政策'
  }
}, {
  path: '/privacyAbstract/:type',
  name: 'privacyAbstract',
  component: privacyAbstract,
  meta: {
    title: '隐私政策摘要'
  }
}, {
  path: '/privacyMerchant',
  name: 'privacyMerchant',
  component: privacyMerchant,
  meta: {
    title: '按个摩商户端隐私政策'
  }
}, {
  path: '/privacyyyjd',
  name: 'privacyyyjd',
  component: privacyyyjd,
  meta: {
    title: '隐私政策'
  }
}, {
  path: '/agreementyyjd',
  name: 'agreementyyjd',
  component: agreementyyjd,
  meta: {
    title: '用户协议'
  }
}, {
  path: '/privacyMechanic',
  name: 'privacyMechanic',
  component: privacyMechanic,
  meta: {
    title: '按个摩技师端隐私政策'
  }
}, {
  path: '/agreement',
  name: 'agreement',
  component: agreement,
  meta: {
    title: '用户协议'
  }
}, {
  path: '/agreement.html',
  name: 'agreement',
  component: agreement,
  meta: {
    title: '用户协议'
  }
},
{
  path: '/agreementJk',
  name: 'agreementJk',
  component: agreementJk,
  meta: {
    title: '用户协议'
  }
}, {
  path: '/privacyJk',
  name: 'privacyJk',
  component: privacyJk,
  meta: {
    title: '隐私政策'
  }
},
{
  path: '/supportJk',
  name: 'supportJk',
  component: supportJk,
  meta: {
    title: '技术支持'
  }
},
{
  path: '/privacy.html',
  name: 'privacy',
  component: privacy,
  meta: {
    title: '隐私政策'
  }
},
{
  path: '/storeSpreadPage',
  name: 'storeSpreadPage',
  component: storeSpreadPage,
  meta: {
    title: '按个摩商户入驻'
  }
},
{
  path: '/distribution',
  name: 'distribution',
  component: distribution,
  meta: {
    title: '登录'
  }
},
{
  path: '/distributionLoadApp',
  name: 'distributionLoadApp',
  component: distributionLoadApp,
  meta: {
    title: '下载App'
  }
},
{
  path: '/storeServe',
  name: 'storeServe',
  component: storeServe,
  meta: {
    title: '按个摩商户入驻'
  }
},
{
  path: '/recruit',
  name: 'recruit',
  component: recruit,
  meta: {
    title: '招募令'
  }
},
{
  path: '/storeExamineResult',
  name: 'storeExamineResult',
  component: storeExamineResult,
  meta: {
    title: '商户入驻'
  }
},
{
  path: '/technicianExamineNotice',
  name: 'technicianExamineNotice',
  component: technicianExamineNotice,
  meta: {
    title: '技师审核公告'
  }
},
{
  path: '/yuean',
  name: 'yuean',
  component: yuean,
  meta: {
    title: '约按'
  }
},
{
  path: '/yuegedan',
  name: 'yuegedan',
  component: yuegedan,
  meta: {
    title: '约个单'
  }
},
{
  path: '/privacy/:type',
  name: 'privacy2',
  component: privacy2,
  meta: {
    title: '隐私政策'
  }
},
{
  path: '/privacy3',
  name: 'privacy3',
  component: privacy3,
  meta: {
    title: '隐私政策'
  }
},
{
  path: '/agreement/:type',
  name: 'agreement2',
  component: agreement2,
  meta: {
    title: '用户协议'
  }
},
{
  path: '/privacy4',
  name: 'privacy4',
  component: privacy4,
  meta: {
    title: '隐私政策'
  }
},
{
  path: '/agreement4',
  name: 'agreement4',
  component: agreement4,
  meta: {
    title: '用户协议'
  }
},
{
  path: '/agreement5',
  name: 'agreement5',
  component: agreement5,
  meta: {
    title: '用户协议'
  }
},
{
  path: '/agreement3',
  name: 'agreement3',
  component: agreement3,
  meta: {
    title: '用户协议'
  }
},
{
  path: '/avatarRequire',
  name: 'avatarRequire',
  component: avatarRequire,
  meta: {
    title: '头像要求'
  }
},
{
  path: '/joinSDKNotice',
  name: 'joinSDKNotice',
  component: joinSDKNotice,
  meta: {
    title: '按个摩app内嵌SDK名单'
  }
},
{
  path: '/userInformation',
  name: 'userInformation',
  component: userInformation,
  meta: {
    title: '个人信息收集清单'
  }
},
{
  path: '/information',
  name: 'information',
  component: information,
  meta: {
    title: '个人信息收集清单'
  }
},
{
  path: '/yyjdPromise',
  name: 'yyjdPromise',
  component: yyjdPromise,
  meta: {
    title: '承诺函'
  }
},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title || '按个摩 - 高品质上门按摩平台'
  }
  next()
})

export default router